import type { CodexNotification } from './index.ts';

/** Exact URL annotation supplied by the model provider. UTF-16, [start, end). */
export interface WebCitation {
  startIndex: number;
  endIndex: number;
  url: string;
  title: string;
  sourceId?: string;
  providerRange?: { startIndex: number; endIndex: number; encoding: 'unicode-scalar' | 'utf16' };
}

export interface WebCitationsEvent extends CodexNotification {
  method: 'reados/webCitations';
  params: {
    ownerThreadId: string;
    threadId: string;
    turnId: string;
    itemId: string;
    /** Monotonic within this exact native item. */
    revision: number;
    /** Complete, unmodified provider text used to verify the native join. */
    text: string;
    citations: WebCitation[];
  };
}

export function isWebCitationsEvent(value: unknown): value is WebCitationsEvent {
  if (!value || typeof value !== 'object') return false;
  const event = value as WebCitationsEvent, p = event.params;
  if (event.method !== 'reados/webCitations' || !p || typeof p !== 'object'
    || ![p.ownerThreadId,p.threadId,p.turnId,p.itemId].every(id => typeof id === 'string' && id.length > 0 && id.length <= 200)
    || !Number.isSafeInteger(p.revision) || p.revision < 1 || typeof p.text !== 'string' || p.text.length > 2 * 1024 * 1024
    || !Array.isArray(p.citations) || p.citations.length > 512) return false;
  return p.citations.every(c => {
    if (!c || !Number.isSafeInteger(c.startIndex) || !Number.isSafeInteger(c.endIndex)
      || c.startIndex < 0 || c.endIndex <= c.startIndex || c.endIndex > p.text.length
      || typeof c.url !== 'string' || c.url.length > 8192 || typeof c.title !== 'string' || c.title.length > 4096
      || c.sourceId !== undefined && (typeof c.sourceId !== 'string' || !c.sourceId || c.sourceId.length > 200)) return false;
    if (c.providerRange && (!Number.isSafeInteger(c.providerRange.startIndex) || !Number.isSafeInteger(c.providerRange.endIndex)
      || c.providerRange.startIndex < 0 || c.providerRange.endIndex <= c.providerRange.startIndex
      || !['unicode-scalar','utf16'].includes(c.providerRange.encoding))) return false;
    try { const url = new URL(c.url); return ['https:', 'http:'].includes(url.protocol) && !url.username && !url.password; }
    catch { return false; }
  });
}
